var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,class:[
        item.url.includes(_vm.defaultItem) ? 'active' : '',
        !index ? 'item-header' : 'item',
      ],on:{"click":function($event){return _vm.navigatorTo(item.url)}}},[_vm._v("\n      "+_vm._s(_vm.TLang(item.title, "user"))+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }